import { useSelections } from 'ahooks';

import { SampleImage } from '@/types';

const useSelectedImages = () => useSelections<SampleImage>([], { itemKey: 'id' });

export default useSelectedImages;
